// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"iconButtonTheme__msignaturepad___2x4F5","m-signature-pad--body":"iconButtonTheme__m-signature-pad--body___2LxWt","m-signature-pad--footer":"iconButtonTheme__m-signature-pad--footer___3MWUa","description":"iconButtonTheme__description___25dt4","button":"iconButtonTheme__button___vzVlL","clear":"iconButtonTheme__clear___2asPm","save":"iconButtonTheme__save___3gS24","m-signature-pad":"iconButtonTheme__m-signature-pad___2VYgy","github":"iconButtonTheme__github___1jZ_2","icon":"iconButtonTheme__icon___SP7jB"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/UploadsTable/iconButtonTheme.scss
// module id = Qt/D
// module chunks = client